import { render, staticRenderFns } from "./ProductSectionsManagement.vue?vue&type=template&id=e1ab73c2&"
import script from "./ProductSectionsManagement.vue?vue&type=script&lang=js&"
export * from "./ProductSectionsManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports